(ns frontend.ui.component.lp-portal.report.company.overview.controller
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [common.util :as cu]))

(defn overview-figures
  [data]

  (concat
   [["Entry date" (:entry-date data)]
    ["EV at entry" (:ev-at-entry data)]
    ["Current EV" (:current-ev data)]
    ["Entry multiple" (:entry-multiple data)]
    ["Gross multiple" (util/->multiple (:gross-multiple data))]
    ["Gross IRR"
     (if (pos? (:gross-irr data))
       (util/->percent-1-decimal (:gross-irr data))
       "N/A")]
    ["Capman funds total investments" (:capman-funds-total-investment data)]
    ["Capman funds total ownership"
     (util/->percent-1-decimal (:capman-funds-total-ownership data))]
    ["Industry" (:industry data)]
    ["Number of employees" (:number-of-employees data)]]
   (when-not (cu/blank-value? (str (:holding-company data)))
     [["Holding company" (:holding-company data)]])
   [["Case team" (:case-team data)]]))

(defn overview-figures-board
  [data]
  ["Board" (:board data)])
